import * as React from 'react';
import styles from './Footer.module.css';

const RF = 'https://www.republicfinance.com';

// "Also of Interest" now matches production and is shown by default.
const SHOW_ALSO_OF_INTEREST = true;

const BASE_COLUMNS = [
  {
    title: 'Support',
    links: [
      { label: 'Contact Us', href: `${RF}/contact` },
      // Confirmed via DevTools: production points this at the contact page too
      { label: 'Questions Or Complaints', href: `${RF}/contact` },
      { label: 'FAQs', href: `${RF}/resources/faq` },
      { label: 'Consumer Alerts', href: `${RF}/consumer-alerts` },
      { label: 'Find A Branch', href: 'https://locations.republicfinance.com/' },
      { label: 'Investors', href: `${RF}/investors` },
    ],
  },
  {
    title: 'Tools',
    links: [
      { label: 'Get Pre-Qualified', href: `${RF}/apps/prequal` },
      { label: 'Continue My Application', href: 'https://secure.republicfinance.com/applyv2/login' },
      { label: 'Enroll In Online Access', href: 'https://secure.republicfinance.com/enroll/' },
      { label: 'Payments', href: `${RF}/payment` },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'History & Values', href: `${RF}/about` },
      { label: 'Our Team', href: `${RF}/about/team` },
      { label: 'News & Updates', href: `${RF}/resources/news` },
      { label: 'Careers', href: 'https://jobs.republicfinance.com/' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Legal & Privacy', href: `${RF}/legal` },
      { label: 'Licenses & Disclosures', href: `${RF}/disclosure` },
      // Confirmed via DevTools: production links straight to the PDF
      {
        label: 'Fee Schedule',
        href: `${RF}/RepublicFinance/media/PDF/7b_Utah_Title_Loan_Schedule_of_Interest_and_Fees.pdf`,
      },
      { label: 'Affiliations', href: `${RF}/learn/affiliations` },
      { label: 'E-Sign Consent', href: `${RF}/consents/sdrconsent` },
    ],
  },
];

// Matches production content instead of the old placeholder loan-product links.
const ALSO_OF_INTEREST = {
  title: 'Also of Interest',
  links: [
    // Confirmed via DevTools against production
    { label: 'Apply For A Loan Online', href: `${RF}/products` },
    {
      label: 'BEWARE! Social Media Scam',
      href: `${RF}/resources/news/october-2020/consumer-alert-new-beware-of-social-media-scams`,
    },
    { label: 'Trusted Since 1952', href: `${RF}/check` },
  ],
};

const COLUMNS = SHOW_ALSO_OF_INTEREST ? [...BASE_COLUMNS, ALSO_OF_INTEREST] : BASE_COLUMNS;

// Plain glyph icons (no boxes) to match the Kentico footer.
const FacebookGlyph = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 320 512" aria-hidden="true">
    <path
      fill="currentColor"
      d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
    />
  </svg>
);

const XGlyph = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512" aria-hidden="true">
    <path
      fill="currentColor"
      d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    />
  </svg>
);

const LinkedInGlyph = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 448 512" aria-hidden="true">
    <path
      fill="currentColor"
      d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    />
  </svg>
);

const InstagramGlyph = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 448 512" aria-hidden="true">
    <path
      fill="currentColor"
      d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    />
  </svg>
);

const SOCIALS = [
  { label: 'Facebook', href: 'https://www.facebook.com/RepublicFinance/', icon: <FacebookGlyph /> },
  { label: 'X', href: 'https://x.com/repfinance', icon: <XGlyph /> },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/republic-finance', icon: <LinkedInGlyph /> },
  { label: 'Instagram', href: 'https://www.instagram.com/republicfinance', icon: <InstagramGlyph /> },
];

const Footer = () => (
  <footer className={styles.footer} data-testid="Footer_Container">
    <div
      className={`${styles.linksBlock} ${SHOW_ALSO_OF_INTEREST ? styles.wide : ''}`}
      style={{ '--footer-cols': COLUMNS.length + 1 }}
      data-testid="Footer_LinksBlock"
    >
      {/* Logo, social icons and copyright */}
      <div className={styles.brand}>
        <a href={RF}>
          <img className={styles.logo} src={`${RF}/RepublicFinance/assets/img/logo.png`} alt="Republic Finance" />
        </a>

        <div className={styles.socials}>
          {SOCIALS.map((s) => (
            <a key={s.label} href={s.href} aria-label={s.label} className={styles.social}>
              {s.icon}
            </a>
          ))}
        </div>

        <p className={styles.copyright}>&copy; {new Date().getFullYear()} Republic Finance</p>
      </div>

      {/* Menu columns */}
      {COLUMNS.map((col) => (
        <nav key={col.title} aria-label={col.title} className={styles.column}>
          <div className={styles.columnTitle}>{col.title}</div>
          <ul className={styles.list}>
            {col.links.map((l) => (
              <li key={l.label}>
                <a href={l.href} className={styles.link}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>

    {/* Disclosures */}
    <div className={styles.disclosures}>
      <p className={styles.disclosure}>
        Loans available through Republic Finance are offered by Republic Finance, LLC or Column N.A. All loans will be
        serviced by Republic Finance, LLC unless otherwise notified. Personal loans in AL, AZ, FL, GA, IN, KY, LA, MS,
        MO, NC, OH, TN, TX, SC, VA, WI are originated by Republic Finance, LLC. In Utah, auto secured loans with a term
        of less than twelve months are originated by Republic Finance, LLC. In Utah, Column, N.A., offers installment
        loans by mail (loan checks). In states where loans are offered by Column N.A., new loans are underwritten,
        approved, and funded by Column N.A. Information received by Republic Finance in connection with your loan
        inquiry related to loans originated by Column N.A. will be shared with Column N.A. Minimum and maximum loan
        amounts and other loan terms depend on applicant&rsquo;s state of residence and applicant&rsquo;s satisfaction
        of eligibility requirements and approval by the applicable lender. Republic Finance, LLC is not a bank.
      </p>

      <p className={`${styles.disclosure} ${styles.patriot}`}>
        USA PATRIOT ACT NOTICE: IMPORTANT INFORMATION ABOUT OPENING A NEW ACCOUNT
        <br />
        To help the government fight the funding of terrorism and money laundering activities, Federal law requires all
        financial institutions to obtain, verify, and record information that identifies each person who opens an
        account. What this means for you: When you open an account, we will ask for your name, address, date of birth,
        and other information that will allow us to identify you. We may also ask to see your driver&rsquo;s license or
        other identifying documents.
      </p>
    </div>
  </footer>
);

// Both export styles, so `import Footer from ...` and `import { Footer } from ...` both work.
export { Footer };
export default Footer;